import { Button, makeStyles } from '@material-ui/core';

import { darkGreen } from 'src/data/colors';

const useStyles = makeStyles({
  clearSelection: {
    backgroundColor: 'transparent',
    color: darkGreen,
    fontSize: 14,
    fontWeight: 500,
    margin: 0,
    minWidth: 'auto',
    padding: 0,
    textTransform: 'none',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

const ClearButton = ({
  onClick,
  label = 'Clear selection',
}: {
  onClick: () => void;
  label?: string;
}) => {
  const classes = useStyles();

  return (
    <Button
      className={classes.clearSelection}
      disableElevation
      disableFocusRipple
      disableRipple
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

export default ClearButton;
